import React from "react";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { HelpArticle, useHelpPanel } from "../../../hooks/useHelpPanel";

interface HelpBubbleProps {
    article: HelpArticle;
}

export const HelpBubble: React.FC<HelpBubbleProps> = ({ article }) => {
    const { openHelp } = useHelpPanel();

    return (
        <button
            type="button"
            onClick={() => openHelp(article)}
            className="rounded-full p-1 text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition-colors"
            title="Help"
        >
            <QuestionMarkCircleIcon className="h-5 w-5" />
        </button>
    );
};
